import axios from 'axios';
import { baseUrl, baseUrl1, decodeJwt, UserRole } from '../Pages/ApiCommonService';
import { expTokenProcessAndGenerate } from './AuthApis';

const token = sessionStorage.getItem('token');

// ------------------------****Api Calls for FileUpload (fetchall_Masterlobs, generateIdforuplodedFiles, jobIdCreation)****-------------------------//

export const createIdForFileUploaded = async (activeTab: any, LobCode: { [key: string]: string }, selectedChecklist: { [key: string]: string }, clientName: { [key: string]: string }, remarks: { [key: string]: string }) => {  // Api call for generate the Id for filesUploaded 

    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const Lob_Code = LobCode[activeTab];

        let MisUser = false;
        const decodedToken = decodeJwt(token);
        if (decodedToken && decodedToken.RoleId === UserRole.MSUser) {
            MisUser = true;
        }

        let userId: any = 0;
        let secondaryUserId: any = 0;
        
        if(MisUser){
            let message = "";
            if(sessionStorage.getItem("selectedCSRUserId")){
                userId = sessionStorage.getItem("selectedCSRUserId")
            }else{
                message = "UserId not found"
                console.error('Error in creating the Id:', message);
                throw message;
            }
            if(sessionStorage.getItem("selectedSecondaryCSRUserId")){
                secondaryUserId = sessionStorage.getItem("selectedSecondaryCSRUserId")
            }

            if(!sessionStorage.getItem('selectedBrokerId')){
                message = "BrokerId not found"
                console.error('Error in creating the Id:', message);
                throw message;
            }
        }   
        const Miuser_brokerid = sessionStorage.getItem('selectedBrokerId');

        const response = await axios.post(`${baseUrl}api/job/createJob`,
            {
                JobTypeId: activeTab === "AutomaticRenewal" ? 1 : 2,
                LobCode: Lob_Code?.toLowerCase() || "",
                MacroFile: selectedChecklist[activeTab] || "",
                ClientName: clientName[activeTab] || "",
                Remarks: remarks[activeTab] || "",
                MisUser: MisUser || false,
                brokerId: MisUser? Miuser_brokerid === "" ? 0 : Miuser_brokerid : 0,
                userId: MisUser ? userId : 0,
                secondaryUserId: MisUser ? secondaryUserId : 0
            },
            {
                headers: { Authorization: `Bearer ${Token}`, "Content-Type": "application/json" },
            }
        );
        sessionStorage.removeItem("isMSUser");
        sessionStorage.removeItem("selectedBrokerId");
        sessionStorage.removeItem("selectedCSRUserId");
        sessionStorage.removeItem("selectedSecondaryCSRUserId");
        sessionStorage.removeItem("enableUploadDocuments");
        return response;
    } catch (error) {
        console.error('Error in creating the Id:', error);
        throw error;
    }
};

export const createJobidForAfterFileUpload = async (jobId: string) => {  // Api call for new jobId creation for the uploded JobType
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(
            baseUrl1 + `backgroundapi/Queue/CreateJobProcessByJobId?jobId=${jobId}&processName=PolicyCheckListProcess`,
            {
                headers: { Authorization: `Bearer ${Token}`, "Content-Type": "application/json" },
            }
        );
        return response;
    } catch (error) {
        console.error('Error in creating the Jobid:', error);
        throw error;
    }
};

export const fetchAllLobs = async () => {        // getApi to fetchall_Masterlob's for line of coverage select field
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + 'api/job/getAllLobnames', {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error in fetching the user:', error);
        throw error;
    }
};

export const fetchAllChecklistType = async () => {        // getApi to fetchall_ChecklistType based on brokerid decode from the user token in backend 
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const decodedToken = decodeJwt(Token);
        
        const MisUser = decodedToken.RoleId === UserRole.MSUser;
        const Miuser_brokerid = sessionStorage.getItem('selectedBrokerId');

        const brokerId = MisUser
            ? Number(Miuser_brokerid)
            : decodedToken?.BrokerId || null;

        const payload = {
            MisUser: MisUser,
            brokerId: brokerId
        };

        const response = await axios.post(baseUrl + 'api/job/getChecklistType', payload, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error in fetching the user:', error);
        throw error;
    }
};

// ----------------------------------------------------------------------------------------------------------------------------//
